import Loader from '@/components/ui/Loader/Loader';
import nf, { nfRp } from '@/constants/nf';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Pagination } from '@mui/material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

export default function OnSiteTopUps({ isFetching, isFetched, topUpList, topUpCount, page, handleChangePagination }) {
	const paymentTypes = useSelector((state) => state.content.paymentTypes);
	const accountType = useSelector((state) => state.auth.accountType);
	const isParent = accountType === 'parent';
	const money = (n) => (isParent ? nfRp(n) : nf(n));

	if (isParent) {
		return (
			<>
				{isFetching && <Loader />}
				{isFetched && topUpList?.length > 0 &&
					topUpList.map((t) => {
						const date = dayjs(new Date(t.date)).format('dddd, D MMMM YYYY');
						return (
							<details key={t.date} className='topup-history-day'>
								<summary>
									<span>{date}</span>
									<ExpandMore fontSize='small' style={{ color: 'var(--jt-muted)' }} />
								</summary>
								<div className='topup-history-body'>
									{t.topUps.map((to) => {
										const isVoid = to.status === 'Void';
										const isDVoid = to.type === 'Deposit void';
										const isCashOut = to.type === 'Cash out';
										const payName =
											paymentTypes.find((p) => p.id === to.payment_type?.id)?.name || '';
										return (
											<div
												key={to.id}
												className={twMerge('topup-history-line', isVoid && 'is-void')}
												style={isVoid ? { textDecoration: 'line-through', color: 'var(--jt-muted)' } : undefined}
											>
												<div>
													<strong>{to.number}</strong>
													<div className='meta'>
														{to.type}
														{payName ? ` · ${payName}` : ''}
													</div>
													{(isVoid || isDVoid) && to.note && (
														<div className='meta'>Reason: {to.note}</div>
													)}
												</div>
												<strong>
													{money(Math.abs(+to.sales_amount) * (isCashOut ? -1 : 1) || 0)}
												</strong>
											</div>
										);
									})}
								</div>
							</details>
						);
					})}
				{isFetched && (!topUpList || topUpList.length === 0) && (
					<p className='orders-empty'>No top up found</p>
				)}
				{isFetched && topUpCount > 1 && (
					<Pagination className='mt-4 ml-auto' count={topUpCount} page={page} onChange={handleChangePagination} />
				)}
			</>
		);
	}

	return (
		<>
			{isFetching && <Loader />}
			{isFetched && topUpList?.length > 0 && (
				<div className='flex flex-col gap-4 mt-4'>
					{topUpList.map((t) => {
						const tItems = t.topUps.map((to) => {
							const isVoid = to.status === 'Void';
							const isDVoid = to.type === 'Deposit void';
							const isCashOut = to.type === 'Cash out';
							const voidStyle = isVoid ? 'line-through text-red-500' : '';

							return (
								<div key={to.id}>
									<table className='w-full table-fixed'>
										<tbody>
											<tr>
												<td className={twMerge('break-words pr-2 align-top w-[30%]', voidStyle)}>{to.number}</td>
												<td className={twMerge('break-words pr-2 text-center align-top w-[20%]', voidStyle)}>{to.type}</td>
												<td className={twMerge('break-words pr-2 text-center align-top w-[23%]', voidStyle)}>
													{paymentTypes.find((p) => p.id === to.payment_type?.id)?.name || ''}
												</td>
												<td className={twMerge('break-words text-right align-top w-[27%]', voidStyle)}>
													{nf(Math.abs(+to.sales_amount) * (isCashOut ? -1 : 1) || 0)}
												</td>
											</tr>
										</tbody>
									</table>
									{(isVoid || isDVoid) && to.note && <span className='w-full pl-2 text-sm italic'>Reason: {to.note}</span>}
								</div>
							);
						});
						const date = dayjs(new Date(t.date)).format('dddd, DD MMMM YYYY');
						return (
							<Accordion key={t.date}>
								<AccordionSummary expandIcon={<ExpandMore />} aria-controls='panel1-content' id='panel1-header'>
									<span className='font-bold'>{date}</span>
								</AccordionSummary>
								<AccordionDetails>
									<div className='flex flex-col gap-2'>
										<div className='flex flex-col gap-1'>{tItems}</div>
									</div>
								</AccordionDetails>
							</Accordion>
						);
					})}
				</div>
			)}
			{isFetched && ((typeof topUpList === 'object' && Object.keys(topUpList).length === 0) || topUpList?.length === 0) && (
				<span className='w-full text-center'>No top up found</span>
			)}
			{isFetched && <Pagination className='mt-4 ml-auto' count={topUpCount} page={page} onChange={handleChangePagination} />}
		</>
	);
}
